import { render, staticRenderFns } from "./sidebar-single-button.vue?vue&type=template&id=0b9abcbc&scoped=true"
import script from "./sidebar-single-button.ts?vue&type=script&lang=ts&external"
export * from "./sidebar-single-button.ts?vue&type=script&lang=ts&external"
import style0 from "./sidebar-single-button.less?vue&type=style&index=0&id=0b9abcbc&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9abcbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b9abcbc')) {
      api.createRecord('0b9abcbc', component.options)
    } else {
      api.reload('0b9abcbc', component.options)
    }
    module.hot.accept("./sidebar-single-button.vue?vue&type=template&id=0b9abcbc&scoped=true", function () {
      api.rerender('0b9abcbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sidebar-multi-option/components/sidebar-single-button.vue"
export default component.exports